import { render, staticRenderFns } from "./examine-detail.vue?vue&type=template&id=8bd09a68&scoped=true"
import script from "./examine-detail.vue?vue&type=script&lang=js"
export * from "./examine-detail.vue?vue&type=script&lang=js"
import style0 from "./examine-detail.vue?vue&type=style&index=0&id=8bd09a68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd09a68",
  null
  
)

export default component.exports